import { useEffect, useState } from 'react'
import { SEARCH_DEBOUNCE_MS } from '../constants'

/**
 * Откладывает значение перед отправкой на бэк.
 * Поиск в списках и выпадашках — серверный, поэтому дребезг гасим здесь, а не фильтрацией на клиенте.
 */
export function useDebouncedValue<T>(value: T, delayMs: number = SEARCH_DEBOUNCE_MS): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(timer)
  }, [value, delayMs])

  return debounced
}
